import {Tooltip} from "@material-ui/core";
import React from "react";

//making all the tickers separate in case they want different breakpoints for the statuses

export const HiringTicker = () => {
	const [mainRole, setMainRole] = React.useState(localStorage.getItem('main_role') ? JSON.parse(localStorage.getItem('main_role')) : null)

	const [data, setData] = React.useState(localStorage.getItem('activeHirings') ? JSON.parse(localStorage.getItem('activeHirings')) : [])

	const intervalRef = React.useRef(null);

	React.useEffect(() => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}

		intervalRef.current = setInterval(() => {
			setMainRole(localStorage.getItem('main_role'))
			setData(localStorage.getItem('activeHirings') ? JSON.parse(localStorage.getItem('activeHirings')) : [])
		}, 1000);

		return () => clearInterval(intervalRef.current);
	}, []);

	return (
		<div style={{backgroundColor: 'lightgrey', width: '100%', marginBottom: 10}}>
			<a style={{fontWeight: 'bold'}} href="/hiring/hiringschedules">Hiring Agents Active: </a>
			{data.length === 0 ? <span>There are no hiring agents active currently.</span> : data.map((item, index) => (
				<Tooltip key={index}
				         title={(item.color === 'black' ? 'Scheduled today but has not been online' : (item.activity_string ? item.activity_string : ''))}
				         arrow>
					<span style={{color: item.color}}>
						{mainRole <= 21 ?
							<a href={`/users/${item.pkey}`} style={{color: item.color}}>{item.name}</a> :
							item.name}
						{index < data.length - 1 && ', '}
					</span>
				</Tooltip>
			))}
		</div>
	)
}